<template>
  <div id="app">
    <!-- Header -->
    <header class="header">
      <div class="container">
        <div class="logo">
          <img :src="require('@/assets/logo.png')" alt="Logo" class="logo-image">
          <span>Kirim Beku</span>
        </div>
        
        <nav class="nav">
          <a href="#home" class="nav-link" :class="{active: activeSection === 'home'}" @click="scrollToSection('home')">Beranda</a>
          <a href="#products" class="nav-link" :class="{active: activeSection === 'products'}" @click="scrollToSection('products')">Produk</a>
          <a href="#cart" class="nav-link" :class="{active: activeSection === 'cart'}" @click="scrollToSection('cart')">Keranjang <span id="cart-count">{{ totalItems }}</span></a>
          <!--a href="#about" class="nav-link" :class="{active: activeSection === 'about'}" @click="scrollToSection('about')">Tentang</a-->
        </nav>
        
        <div class="header-actions">
          <div class="promo-banner">
            <span id="promo-label">{{ discountConfig.globalPromoLabel }}</span>
          </div>
          <button id="theme-toggle" class="theme-toggle" aria-label="Ubah tema" @click="toggleTheme">
            <i class="fas" :class="currentTheme === 'light' ? 'fa-moon' : 'fa-sun'"></i>
          </button>
          <button class="btn btn-outline" id="wa-button" @click="openCheckoutModal">
            <i class="fab fa-whatsapp"></i> WhatsApp
          </button>
        </div>
        
        <button class="mobile-menu-btn" id="mobile-menu-btn" @click="toggleMobileMenu">
          <i class="fas fa-bars"></i>
        </button>
      </div>
    </header>
    
    <!-- Mobile Menu -->
    <div class="mobile-menu" :class="{active: mobileMenuOpen}">
      <a href="#home" class="mobile-nav-link" :class="{active: activeSection === 'home'}" @click="scrollToSection('home')">Beranda</a>
      <a href="#products" class="mobile-nav-link" :class="{active: activeSection === 'products'}" @click="scrollToSection('products')">Produk</a>
      <a href="#cart" class="mobile-nav-link" :class="{active: activeSection === 'cart'}" @click="scrollToSection('cart')">Keranjang <span id="mobile-cart-count">{{ totalItems }}</span></a>
      <!--a href="#about" class="mobile-nav-link" :class="{active: activeSection === 'about'}" @click="scrollToSection('about')">Tentang</a-->
      <button id="mobile-theme-toggle" class="mobile-theme-toggle" @click="toggleTheme">
        <i class="fas" :class="currentTheme === 'light' ? 'fa-moon' : 'fa-sun'"></i> {{ currentTheme === 'light' ? 'Mode Gelap' : 'Mode Terang' }}
      </button>
    </div>
    
    <!-- Main Content -->
    <main class="main-content">
      <!-- Hero Section -->
      <!--section class="hero" id="home">
        <div class="container">
          <div class="hero-content">
            <h1>Ikan Asap Berkualitas Premium</h1>
            <p>Rasa otentik, diolah dengan teknik tradisional, dikirim beku via Paxel untuk menjaga kesegaran.</p>
            <a href="#products" class="btn btn-primary" @click="scrollToSection('products')">Lihat Produk</a>
          </div>
          <div class="hero-image">
            <img src="https://p16-images-sign-sg.tokopedia-static.net/tos-alisg-i-aphluv4xwc-sg/93889d7c1f694d6c956008b8d118a1cb~tplv-aphluv4xwc-white-pad-v1:1600:1600.jpeg?lk3s=0ccea506&x-expires=1767865312&x-signature=F3nkNII%2B1ud2ColhJLlvWxKQEzQ%3D&x-signature-webp=IVl5AK51ybJmGHWm8iEE%2FH1DGU8%3D?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Iwak Pe Asep">
          </div>
        </div>
      </section-->
      
      <!-- Products Section -->
      <section class="products-section" id="products">
        <div class="container">
          <!--h2 class="section-title">Produk Iwak Pe Asep</h2>
          <p class="section-subtitle">Berbagai jenis ikan asap pilihan dengan varian berat berbeda</p-->
          
          <div class="products-filter">
            <button class="filter-btn" :class="{active: activeFilter === 'all'}" @click="setFilter('all')" data-filter="all">Semua</button>
            <button class="filter-btn" :class="{active: activeFilter === 'popular'}" @click="setFilter('popular')" data-filter="popular">Terlaris</button>
            <button class="filter-btn" :class="{active: activeFilter === 'new'}" @click="setFilter('new')" data-filter="new">Baru</button>
            <button class="filter-btn" :class="{active: activeFilter === 'in-stock'}" @click="setFilter('in-stock')" data-filter="in-stock">Ready Stok</button>
            <button class="filter-btn" :class="{active: activeFilter === 'discount'}" @click="setFilter('discount')" data-filter="discount">Promo</button>
          </div>
          
          <div class="products-grid">
            <div class="product-card" v-for="product in filteredProducts" :key="product.id" :data-category="product.category">
              <div class="product-badge" v-if="product.maxDiscount > 0">
                <div class="discount-badge">
                  <i class="fas fa-tag"></i>
                  <span>{{ product.discountLabel }} {{ product.maxDiscount }}%</span>
                </div>
              </div>
              
              <img :src="product.image" :alt="product.name" class="product-image">
              <div class="product-info">
                <h3 class="product-name">{{ product.name }}</h3>
                <p class="product-description">{{ product.description }}</p>
                
                <div class="product-pricing">
                  <div class="original-price" v-if="product.selectedVariant.discount > 0">Rp {{ formatPrice(product.selectedVariant.price) }}</div>
                  <div :class="product.selectedVariant.discount > 0 ? 'discounted-price' : 'product-price'">
                    Rp {{ formatPrice(product.selectedVariant.discountedPrice) }}
                  </div>
                </div>
                
                <div class="product-stock">
                  <div class="stock-badge" :class="product.stockClass">{{ product.stockText }}</div>
                  <span v-if="product.totalStock > 0">({{ product.totalStock }} tersedia)</span>
                </div>
                
                <div class="variant-selector">
                  <label>Pilih Berat:</label>
                  <div class="variant-buttons">
                    <button 
                      class="variant-btn" 
                      v-for="(variant, index) in product.variants" 
                      :key="index"
                      :class="{active: variant.weight === product.selectedVariant.weight}"
                      :disabled="variant.stock === 0"
                      @click="selectVariant(product.id, variant.weight)"
                      :data-product-id="product.id"
                      :data-weight="variant.weight"
                      :data-price="variant.price"
                      :data-discount="variant.discount"
                      :data-index="index">
                      {{ variant.weight }}
                    </button>
                  </div>
                </div>
                
                <button 
                  class="btn btn-primary add-to-cart-btn" 
                  :disabled="product.selectedVariant.stock === 0"
                  @click="addToCart(product)">
                  <i class="fas fa-cart-plus"></i> 
                  {{ product.selectedVariant.stock === 0 ? 'Stok Habis' : 'Tambah ke Keranjang' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- Cart Section -->
      <section class="cart-section" id="cart">
        <div class="container">
          <h2 class="section-title">Keranjang Belanja</h2>
          
          <div class="cart-container">
            <div class="cart-items" id="cart-items">
              <div class="empty-cart" v-if="cart.length === 0">
                <i class="fas fa-shopping-cart"></i>
                <p>Keranjang belanja Anda masih kosong</p>
                <a href="#products" class="btn btn-outline" @click="scrollToSection('products')">Lihat Produk</a>
              </div>
              
              <div class="cart-item" v-for="(item, index) in cart" :key="index">
                <img :src="item.image" :alt="item.name" class="cart-item-image">
                <div class="cart-item-details">
                  <h4 class="cart-item-name">{{ item.name }}</h4>
                  <p class="cart-item-variant">Berat: {{ item.variant.weight }}</p>
                  
                  <div class="cart-item-pricing">
                    <span class="cart-item-price">Rp {{ formatPrice(item.variant.discountedPrice * item.quantity) }}</span>
                    <span class="cart-item-original-price" v-if="item.variant.discount > 0">Rp {{ formatPrice(item.variant.price * item.quantity) }}</span>
                    <span class="cart-item-discount" v-if="item.variant.discount > 0">-{{ item.variant.discount }}%</span>
                  </div>
                  
                  <div class="cart-item-actions">
                    <div class="quantity-control">
                      <button class="quantity-btn decrease-quantity" @click="decreaseQuantity(index)">
                        <i class="fas fa-minus"></i>
                      </button>
                      <span class="quantity">{{ item.quantity }}</span>
                      <button class="quantity-btn increase-quantity" 
                              @click="increaseQuantity(index)"
                              :disabled="getVariantStock(item.id, item.variant.weight) === 0">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                    <button class="remove-item" @click="removeItem(index)">
                      <i class="fas fa-trash"></i> Hapus
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="cart-summary">
              <h3>Ringkasan Belanja</h3>
              <div class="summary-item">
                <span>Subtotal</span>
                <span id="subtotal">Rp {{ formatPrice(subtotal) }}</span>
              </div>
              <div class="summary-item discount" v-if="totalDiscount > 0">
                <span>Diskon</span>
                <span id="discount-total">-Rp {{ formatPrice(totalDiscount) }}</span>
              </div>
              <div class="summary-item">
                <span>Pengiriman (Paxel Beku)</span>
                <span id="shipping-cost">Rp {{ formatPrice(shippingCost) }}</span>
              </div>
              <div class="summary-item total">
                <span>Total</span>
                <span id="total">Rp {{ formatPrice(total) }}</span>
              </div>
              
              <button class="btn btn-primary btn-block" 
                      id="checkout-btn" 
                      :disabled="cart.length === 0"
                      @click="openCheckoutModal">
                <i class="fas fa-shopping-bag"></i> Lanjut ke Checkout
              </button>
            </div>
          </div>
        </div>
      </section>
      
      <!-- About Section -->
      <!--section class="about-section" id="about">
        <div class="container">
          <h2 class="section-title">Tentang Kami</h2>
          <div class="about-content">
            <div class="about-text">
              <p><strong>Iwak Pe Asep</strong> menyediakan ikan asap berkualitas pilihan dengan jenis varian berbeda. Setiap ikan diolah dengan teknik tradisional untuk mempertahankan cita rasa otentik.</p>
              <p>Kami menggunakan layanan pengiriman <strong>Paxel Beku</strong> untuk memastikan produk tetap segar sampai ke tangan Anda.</p>
              <div class="features">
                <div class="feature">
                  <i class="fas fa-shipping-fast"></i>
                  <span>Pengiriman Cepat</span>
                </div>
                <div class="feature">
                  <i class="fas fa-snowflake"></i>
                  <span>Dikirim Beku</span>
                </div>
                <div class="feature">
                  <i class="fas fa-check-circle"></i>
                  <span>Kualitas Terjamin</span>
                </div>
              </div>
            </div>
            <div class="about-image">
              <img src="https://p16-images-sign-sg.tokopedia-static.net/tos-alisg-i-aphluv4xwc-sg/63224444398f4ce2b6163e88c43e753e~tplv-aphluv4xwc-resize-jpeg:700:0.jpeg?lk3s=0ccea506&x-expires=1767865820&x-signature=lc657sIzRPTi%2FQe9ao9ITuh%2BtGY%3D&x-signature-webp=DK6sFdCVT9ocbxGRhY821kNreWw%3D?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Proses Pengolahan Ikan Asap">
            </div>
          </div>
        </div>
      </section-->
    </main>
    
    <!-- Footer -->
    <footer class="footer">
      <div class="container">
        <!--div class="footer-content">
          <div class="footer-logo">
            <i class="fas fa-fish"></i>
            <span>Iwak Pe Asep</span>
          </div>
          <div class="footer-info">
            <p><i class="fas fa-map-marker-alt"></i> Jakenan, Kab. Pati, Jawa Tengah. 59182</p>
            <p><i class="fas fa-phone"></i> +62 889-8511-4082</p>
            <p><i class="fas fa-envelope"></i> iwakpeasep@gmail.com</p>
          </div>
          <div class="footer-social">
            <a href="#"><i class="fab fa-whatsapp"></i></a>
            <a href="#"><i class="fab fa-instagram"></i></a>
            <a href="#"><i class="fab fa-facebook"></i></a>
          </div>
        </div-->
        <div class="footer-bottom">
          <p>&copy; 2026 Iwak Pe Asep. Hak Cipta Dilindungi.</p>
        </div>
      </div>
    </footer>
    
    <!-- Checkout Modal -->
    <div class="modal" :class="{active: checkoutModalOpen}">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Formulir Checkout</h3>
          <button class="modal-close" id="modal-close" @click="closeCheckoutModal">&times;</button>
        </div>
        <div class="modal-body">
          <form id="checkout-form" @submit.prevent="submitCheckoutForm">
            <div class="form-group">
              <label for="name">Nama Lengkap</label>
              <input type="text" id="name" v-model="checkoutForm.name" required>
            </div>
            
            <div class="form-group">
              <label for="phone">Nomor WhatsApp</label>
              <input type="tel" id="phone" v-model="checkoutForm.phone" required>
            </div>
            
            <div class="form-group">
              <label for="address">Alamat Lengkap</label>
              <textarea id="address" rows="4" v-model="checkoutForm.address" required></textarea>
            </div>
            
            <div class="form-group">
              <label for="city">Kota</label>
              <input type="text" id="city" v-model="checkoutForm.city" required>
            </div>
            
            <div class="form-group">
              <label for="postal-code">Kode Pos</label>
              <input type="text" id="postal-code" v-model="checkoutForm.postalCode" required>
            </div>
            
            <div class="form-group">
              <label for="notes">Catatan (opsional)</label>
              <textarea id="notes" rows="3" v-model="checkoutForm.notes" placeholder="Catatan untuk penjual atau instruksi pengiriman"></textarea>
            </div>
            
            <div class="order-summary">
              <h4>Ringkasan Pesanan</h4>
              <div id="modal-order-summary">
                <div class="order-item" v-for="(item, index) in cart" :key="index">
                  <span>{{ item.name }} ({{ item.variant.weight }}) x{{ item.quantity }}</span>
                  <span v-if="item.variant.discount > 0">
                    Rp {{ formatPrice(item.variant.discountedPrice * item.quantity) }} 
                    <small style="text-decoration: line-through; color: #888; margin-left: 5px;">
                      Rp {{ formatPrice(item.variant.price * item.quantity) }}
                    </small>
                  </span>
                  <span v-else>Rp {{ formatPrice(item.variant.discountedPrice * item.quantity) }}</span>
                </div>
                
                <div class="order-item">
                  <span>Subtotal</span>
                  <span>Rp {{ formatPrice(subtotal) }}</span>
                </div>
                
                <div class="order-item" v-if="totalDiscount > 0">
                  <span>Diskon</span>
                  <span>-Rp {{ formatPrice(totalDiscount) }}</span>
                </div>
                
                <div class="order-item">
                  <span>Pengiriman (Paxel Beku)</span>
                  <span>Rp {{ formatPrice(shippingCost) }}</span>
                </div>
                
                <div class="order-item">
                  <strong>Total</strong>
                  <strong>Rp {{ formatPrice(total) }}</strong>
                </div>
                
                <div class="order-item payment-method-display">
                  <strong>Metode Pembayaran</strong>
                  <strong>{{ checkoutForm.paymentMethod }}</strong>
                </div>
              </div>
            </div>
            
            <!-- Metode Pembayaran -->
            <div class="form-group">
              <label>Metode Pembayaran</label>
              <div class="payment-methods">
                <div class="payment-category">
                  <h4>E-wallet</h4>
                  <div class="payment-options">
                    <label class="payment-option">
                      <input type="radio" name="payment-method" value="Dana" v-model="checkoutForm.paymentMethod">
                      <div class="payment-card">
                        <div class="payment-icon">
                          <i class="fas fa-wallet"></i>
                        </div>
                        <div class="payment-info">
                          <span class="payment-name">Dana</span>
                          <span class="payment-desc">Bayar via Dana</span>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                
                <div class="payment-category">
                  <h4>Transfer Bank</h4>
                  <div class="payment-options">
                    <label class="payment-option">
                      <input type="radio" name="payment-method" value="BRI" v-model="checkoutForm.paymentMethod">
                      <div class="payment-card">
                        <div class="payment-icon">
                          <i class="fas fa-university"></i>
                        </div>
                        <div class="payment-info">
                          <span class="payment-name">BRI</span>
                          <span class="payment-desc">Bank Rakyat Indonesia</span>
                        </div>
                      </div>
                    </label>
                    
                    <label class="payment-option">
                      <input type="radio" name="payment-method" value="BNI" v-model="checkoutForm.paymentMethod">
                      <div class="payment-card">
                        <div class="payment-icon">
                          <i class="fas fa-university"></i>
                        </div>
                        <div class="payment-info">
                          <span class="payment-name">BNI</span>
                          <span class="payment-desc">Bank Negara Indonesia</span>
                        </div>
                      </div>
                    </label>
                    
                    <label class="payment-option">
                      <input type="radio" name="payment-method" value="BCA" v-model="checkoutForm.paymentMethod">
                      <div class="payment-card">
                        <div class="payment-icon">
                          <i class="fas fa-university"></i>
                        </div>
                        <div class="payment-info">
                          <span class="payment-name">BCA</span>
                          <span class="payment-desc">Bank Central Asia</span>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="form-actions">
              <button type="button" class="btn btn-outline" @click="closeCheckoutModal">Batal</button>
              <button type="submit" class="btn btn-primary" id="send-whatsapp">
                <i class="fab fa-whatsapp"></i> Kirim via WhatsApp
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    
    <!-- Notification -->
    <div class="notification" :class="[{active: notification.show}, notification.type]">
      <span id="notification-message">{{ notification.message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      // Data produk ikan asap dengan stok dan diskon per varian
      products: [
        {
          id: 1,
          name: "Ikan Asap Pari / PE",
          description: "Ikan pari asap dengan rasa gurih dan aroma khas, tidak bau pesing.",
          discountLabel: "Diskon",
          image: require("@/assets/iwakpepari.jpg"),
          variants: [
            { weight: "250gr isi 6", price: 35000, discount: 5, stock: 10 },
            { weight: "500gr isi 12", price: 70000, discount: 5, stock: 10 },
            { weight: "1kg isi 24", price: 135000, discount: 5, stock: 10 }
          ],
          category: "popular",
          selectedVariant: null
        },
        {
          id: 2,
          name: "Ekor Ikan Pari Asap",
          description: "Bagian ekor ikan pari asap dengan tekstur lembut dan panjang.",
          discountLabel: "Promo",
          image: require("@/assets/iwakpeekorpari.jpg"),
          variants: [
            { weight: "250gr isi 6", price: 35000, discount: 0, stock: 18 },
            { weight: "500gr isi 12", price: 70000, discount: 0, stock: 13 },
            { weight: "1kg isi 24", price: 135000, discount: 0, stock: 0 }
          ],
          category: "popular",
          selectedVariant: null
        },
        {
          id: 3,
          name: "Kepala Ikan Manyung Asap",
          description: "Kepala ikan manyung asap (ndas mangut) dengan daging tebal di sela-sela tulang dan rasa yang nikmat.",
          discountLabel: "Diskon",
          image: require("@/assets/iwakpendasmayung.jpg"),
          variants: [
            { weight: "800gr isi 2", price: 50000, discount: 0, stock: 10 },
            { weight: "1kg isi 2", price: 60000, discount: 0, stock: 10 },
            { weight: "2kg isi 4", price: 120000, discount: 0, stock: 10 }
          ],
          category: "new",
          selectedVariant: null
        },
        {
          id: 4,
          name: "Ikan Manyung Asap",
          description: "Ikan manyung asap premium dengan rasa lembut dan kaya nutrisi.",
          discountLabel: "Promo",
          image: require("@/assets/iwakpemanyung.jpg"),
          variants: [
            { weight: "250gr isi 6", price: 35000, discount: 5, stock: 150 },
            { weight: "500gr isi 12", price: 70000, discount: 5, stock: 88 },
            { weight: "1kg isi 24", price: 135000, discount: 5, stock: 73 }
          ],
          category: "popular",
          selectedVariant: null
        },
        {
          id: 5,
          name: "Ikan Salem Asap",
          description: "Ikan salem asap atau ikan makerel sama dengan bahan olahan sarden kaleng.",
          discountLabel: "Diskon",
          image: require("@/assets/iwakpesalem.jpg"),
          variants: [
            { weight: "600gr isi 3", price: 42000, discount: 5, stock: 20 },
            { weight: "1kg isi 5", price: 70000, discount: 5, stock: 12 },
            { weight: "2kg isi 10", price: 135000, discount: 5, stock: 15 }
          ],
          category: "new",
          selectedVariant: null
        },
        {
          id: 6,
          name: "Ikan Badeng Asap",
          description: "Ikan bandeng asap dengan tekstur lembut dan belum dipresto.",
          discountLabel: "Diskon",
          image: require("@/assets/iwakpebandeng.jpg"),
          variants: [
            { weight: "600gr isi 3", price: 30000, discount: 0, stock: 10 },
            { weight: "1kg isi 5", price: 55000, discount: 5, stock: 10 },
            { weight: "2kg isi 10", price: 105000, discount: 0, stock: 10 }
          ],
          category: "popular",
          selectedVariant: null
        },
        {
          id: 7,
          name: "Ikan Bagong Asap",
          description: "Ikan bagong asap dengan rasa gurih alami dan nikmat.",
          discountLabel: "Hemat",
          image: require("@/assets/iwakpebagong.jpg"),
          variants: [
            { weight: "850gr isi 3", price: 32000, discount: 5, stock: 17 },
            { weight: "1,2kg isi 5", price: 50000, discount: 5, stock: 14 },
            { weight: "2,5kg isi 10", price: 98000, discount: 5, stock: 11 }
          ],
          category: "new",
          selectedVariant: null
        },
        {
          id: 8,
          name: "Ikan Baby Tuna Asap",
          description: "Ikan baby tuna asap dengan daging tebal dan cocok untuk santapan keluarga.",
          discountLabel: "Diskon",
          image: require("@/assets/iwakpebabytuna.jpg"),
          variants: [
            { weight: "450gr isi 3", price: 32000, discount: 0, stock: 0 },
            { weight: "900gr isi 5", price: 50000, discount: 0, stock: 0 },
            { weight: "1,8kg isi 10", price: 98000, discount: 0, stock: 0 }
          ],
          category: "popular",
          selectedVariant: null
        },
        {
          id: 9,
          name: "Ikan Dorang Asap",
          description: "Ikan dorang asap dengan daging putih bersih dan rasa yang lembut.",
          discountLabel: "Flash Sale",
          image: require("@/assets/iwakpedorang.jpg"),
          variants: [
            { weight: "1kg isi 2", price: 55000, discount: 5, stock: 0 },
            { weight: "2kg isi 4", price: 95000, discount: 5, stock: 0 },
            { weight: "4kg isi 8", price: 185000, discount: 5, stock: 0 }
          ],
          category: "new",
          selectedVariant: null
        },
        {
          id: 10,
          name: "Ikan Demang Asap",
          description: "Ikan demang asap dengan daging premium dan tekstur yang padat.",
          discountLabel: "Diskon",
          image: require("@/assets/iwakpedemang.jpg"),
          variants: [
            { weight: "450gr isi 3", price: 32000, discount: 0, stock: 0 },
            { weight: "900gr isi 5", price: 50000, discount: 0, stock: 0 },
            { weight: "1,8kg isi 10", price: 96000, discount: 0, stock: 0 }
          ],
          category: "popular",
          selectedVariant: null
        },
        {
          id: 11,
          name: "Ikan Sunglir Asap",
          description: "Ikan sunglir asap kecil dengan rasa khas dan cocok untuk camilan.",
          discountLabel: "Diskon",
          image: require("@/assets/iwakpesunglir.jpg"),
          variants: [
            { weight: "600gr isi 3", price: 42000, discount: 0, stock: 0 },
            { weight: "1kg isi 5", price: 70000, discount: 5, stock: 0 },
            { weight: "2kg isi 10", price: 135000, discount: 0, stock: 0 }
          ],
          category: "new",
          selectedVariant: null
        },
        {
          id: 12,
          name: "Ikan Petek Asap",
          description: "Ikan petek asap dengan rasa manis gurih khas ikan air tawar.",
          discountLabel: "Promo",
          image: require("@/assets/iwakpepetek.jpg"),
          variants: [
            { weight: "600gr isi 3", price: 42000, discount: 0, stock: 0 },
            { weight: "1kg isi 5", price: 70000, discount: 5, stock: 0 },
            { weight: "2kg isi 10", price: 135000, discount: 0, stock: 0 }
          ],
          category: "popular",
          selectedVariant: null
        }
      ],
      
      cart: [],
      currentTheme: 'light',
      mobileMenuOpen: false,
      checkoutModalOpen: false,
      activeSection: 'home',
      activeFilter: 'all',
      
      discountConfig: {
        defaultLabel: "Diskon",
        globalPromoLabel: "Promo Spesial",
        showOriginalPrice: true
      },
      
      checkoutForm: {
        name: "Nama Lengkap",
        phone: "6281234567890",
        address: "Jl. Contoh No. 123, Kelurahan Contoh",
        city: "Jakarta Selatan",
        postalCode: "12345",
        notes: "",
        paymentMethod: "Dana"
      },
      
      notification: {
        show: false,
        message: "",
        type: "success"
      },
      
      shippingCost: 25000
    };
  },
  
  computed: {
    totalItems() {
      return this.cart.reduce((sum, item) => sum + item.quantity, 0);
    },
    
    subtotal() {
      return this.cart.reduce((sum, item) => sum + (item.variant.discountedPrice * item.quantity), 0);
    },
    
    originalSubtotal() {
      return this.cart.reduce((sum, item) => sum + (item.variant.price * item.quantity), 0);
    },
    
    totalDiscount() {
      return this.originalSubtotal - this.subtotal;
    },
    
    total() {
      return this.subtotal + this.shippingCost;
    },
    
    filteredProducts() {
      let filtered = [...this.products];
      
      if (this.activeFilter === 'all') {
        return filtered;
      } else if (this.activeFilter === 'popular' || this.activeFilter === 'new') {
        return filtered.filter(product => product.category === this.activeFilter);
      } else if (this.activeFilter === 'in-stock') {
        return filtered.filter(product => product.totalStock > 0);
      } else if (this.activeFilter === 'discount') {
        return filtered.filter(product => product.maxDiscount > 0);
      }
      
      return filtered;
    }
  },
  
  mounted() {
    // Inisialisasi produk dengan selectedVariant
    this.initializeProducts();
    
    // Inisialisasi tema
    this.initializeTheme();
    
    // Muat cart dari localStorage
    this.loadCartFromStorage();
    
    // Set observer untuk section aktif
    this.setupScrollObserver();
    
    // Set nilai default untuk form checkout
    this.setDefaultCheckoutForm();
  },
  
  methods: {
    initializeProducts() {
      this.products.forEach(product => {
        // Hitung total stok dan diskon maksimal
        product.totalStock = product.variants.reduce((sum, variant) => sum + variant.stock, 0);
        product.maxDiscount = Math.max(...product.variants.map(v => v.discount));
        
        // Tentukan badge stok
        if (product.totalStock > 5) {
          product.stockClass = 'stock-in';
          product.stockText = 'Ready Stok';
        } else if (product.totalStock > 0) {
          product.stockClass = 'stock-low';
          product.stockText = 'Stok Terbatas';
        } else {
          product.stockClass = 'stock-out';
          product.stockText = 'Stok Habis';
        }
        
        // Set varian pertama yang tersedia sebagai default
        const firstAvailableVariant = product.variants.find(v => v.stock > 0) || product.variants[0];
        product.selectedVariant = {
          ...firstAvailableVariant,
          discountedPrice: this.calculateDiscountedPrice(firstAvailableVariant.price, firstAvailableVariant.discount)
        };
      });
    },
    
    calculateDiscountedPrice(originalPrice, discountPercent) {
      if (discountPercent <= 0) return originalPrice;
      return Math.round(originalPrice * (100 - discountPercent) / 100);
    },
    
    formatPrice(price) {
      return price.toLocaleString('id-ID');
    },
    
    selectVariant(productId, weight) {
      const product = this.products.find(p => p.id === productId);
      const variant = product.variants.find(v => v.weight === weight);
      
      if (variant) {
        product.selectedVariant = {
          ...variant,
          discountedPrice: this.calculateDiscountedPrice(variant.price, variant.discount)
        };
      }
    },
    
    addToCart(product) {
      const variant = product.selectedVariant;
      
      if (variant.stock <= 0) {
        this.showNotification(`Stok ${product.name} (${variant.weight}) habis!`, 'error');
        return;
      }
      
      const existingItemIndex = this.cart.findIndex(item => 
        item.id === product.id && item.variant.weight === variant.weight
      );
      
      if (existingItemIndex !== -1) {
        // Cek apakah masih ada stok untuk menambah kuantitas
        if (this.cart[existingItemIndex].quantity >= variant.stock) {
          this.showNotification(`Stok ${product.name} (${variant.weight}) hanya tersisa ${variant.stock}!`, 'warning');
          return;
        }
        this.cart[existingItemIndex].quantity += 1;
      } else {
        this.cart.push({
          id: product.id,
          name: product.name,
          image: product.image,
          variant: {
            weight: variant.weight,
            price: variant.price,
            discountedPrice: variant.discountedPrice,
            discount: variant.discount
          },
          quantity: 1
        });
      }
      
      // Kurangi stok
      variant.stock -= 1;
      product.totalStock = product.variants.reduce((sum, v) => sum + v.stock, 0);
      
      // Update badge stok
      if (product.totalStock > 5) {
        product.stockClass = 'stock-in';
        product.stockText = 'Ready Stok';
      } else if (product.totalStock > 0) {
        product.stockClass = 'stock-low';
        product.stockText = 'Stok Terbatas';
      } else {
        product.stockClass = 'stock-out';
        product.stockText = 'Stok Habis';
      }
      
      // Simpan ke localStorage
      this.saveCartToStorage();
      
      this.showNotification(`${product.name} (${variant.weight}) ditambahkan ke keranjang!`);
    },
    
    decreaseQuantity(index) {
      const item = this.cart[index];
      const product = this.products.find(p => p.id === item.id);
      const variant = product.variants.find(v => v.weight === item.variant.weight);
      
      if (item.quantity > 1) {
        item.quantity -= 1;
        // Kembalikan stok
        if (variant) variant.stock += 1;
      } else {
        this.cart.splice(index, 1);
        // Kembalikan semua stok
        if (variant) variant.stock += item.quantity;
      }
      
      // Update total stok produk
      if (product) {
        product.totalStock = product.variants.reduce((sum, v) => sum + v.stock, 0);
        
        // Update badge stok
        if (product.totalStock > 5) {
          product.stockClass = 'stock-in';
          product.stockText = 'Ready Stok';
        } else if (product.totalStock > 0) {
          product.stockClass = 'stock-low';
          product.stockText = 'Stok Terbatas';
        } else {
          product.stockClass = 'stock-out';
          product.stockText = 'Stok Habis';
        }
      }
      
      this.saveCartToStorage();
    },
    
    increaseQuantity(index) {
      const item = this.cart[index];
      const product = this.products.find(p => p.id === item.id);
      const variant = product.variants.find(v => v.weight === item.variant.weight);
      
      // Cek stok tersedia
      if (variant && variant.stock > 0) {
        item.quantity += 1;
        variant.stock -= 1;
        
        // Update total stok produk
        product.totalStock = product.variants.reduce((sum, v) => sum + v.stock, 0);
        
        // Update badge stok
        if (product.totalStock > 5) {
          product.stockClass = 'stock-in';
          product.stockText = 'Ready Stok';
        } else if (product.totalStock > 0) {
          product.stockClass = 'stock-low';
          product.stockText = 'Stok Terbatas';
        } else {
          product.stockClass = 'stock-out';
          product.stockText = 'Stok Habis';
        }
        
        this.saveCartToStorage();
      } else {
        this.showNotification(`Stok ${item.name} (${item.variant.weight}) habis!`, 'warning');
      }
    },
    
    removeItem(index) {
      const item = this.cart[index];
      const product = this.products.find(p => p.id === item.id);
      const variant = product.variants.find(v => v.weight === item.variant.weight);
      
      // Kembalikan stok
      if (variant) variant.stock += item.quantity;
      
      // Update total stok produk
      if (product) {
        product.totalStock = product.variants.reduce((sum, v) => sum + v.stock, 0);
        
        // Update badge stok
        if (product.totalStock > 5) {
          product.stockClass = 'stock-in';
          product.stockText = 'Ready Stok';
        } else if (product.totalStock > 0) {
          product.stockClass = 'stock-low';
          product.stockText = 'Stok Terbatas';
        } else {
          product.stockClass = 'stock-out';
          product.stockText = 'Stok Habis';
        }
      }
      
      this.cart.splice(index, 1);
      this.saveCartToStorage();
      
      this.showNotification(`${item.name} (${item.variant.weight}) dihapus dari keranjang!`);
    },
    
    getVariantStock(productId, weight) {
      const product = this.products.find(p => p.id === productId);
      const variant = product?.variants.find(v => v.weight === weight);
      return variant ? variant.stock : 0;
    },
    
    saveCartToStorage() {
      localStorage.setItem('cart', JSON.stringify(this.cart));
    },
    
    loadCartFromStorage() {
      const savedCart = localStorage.getItem('cart');
      if (savedCart) {
        this.cart = JSON.parse(savedCart);
        
        // Sync stok dengan data produk
        this.cart.forEach(item => {
          const product = this.products.find(p => p.id === item.id);
          if (product) {
            const variant = product.variants.find(v => v.weight === item.variant.weight);
            if (variant) {
              // Kurangi stok berdasarkan jumlah di keranjang
              variant.stock -= item.quantity;
              if (variant.stock < 0) variant.stock = 0;
            }
          }
        });
        
        // Update total stok semua produk
        this.products.forEach(product => {
          product.totalStock = product.variants.reduce((sum, v) => sum + v.stock, 0);
          
          // Update badge stok
          if (product.totalStock > 5) {
            product.stockClass = 'stock-in';
            product.stockText = 'Ready Stok';
          } else if (product.totalStock > 0) {
            product.stockClass = 'stock-low';
            product.stockText = 'Stok Terbatas';
          } else {
            product.stockClass = 'stock-out';
            product.stockText = 'Stok Habis';
          }
        });
      }
    },
    
    initializeTheme() {
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
        this.currentTheme = savedTheme;
      }
      document.documentElement.setAttribute('data-theme', this.currentTheme);
    },
    
    toggleTheme() {
      this.currentTheme = this.currentTheme === 'light' ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', this.currentTheme);
      localStorage.setItem('theme', this.currentTheme);
      this.mobileMenuOpen = false;
    },
    
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    
    scrollToSection(sectionId) {
      this.activeSection = sectionId;
      const element = document.getElementById(sectionId);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: 'smooth'
        });
      }
      this.mobileMenuOpen = false;
    },
    
    setupScrollObserver() {
      const sections = ['home', 'products', 'cart', 'about'];
      const observerOptions = {
        root: null,
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0
      };
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.activeSection = entry.target.id;
          }
        });
      }, observerOptions);
      
      sections.forEach(sectionId => {
        const element = document.getElementById(sectionId);
        if (element) observer.observe(element);
      });
    },
    
    setFilter(filter) {
      this.activeFilter = filter;
    },
    
    openCheckoutModal() {
      if (this.cart.length === 0) {
        this.showNotification('Keranjang belanja masih kosong', 'warning');
        return;
      }
      this.checkoutModalOpen = true;
      document.body.style.overflow = 'hidden';
    },
    
    closeCheckoutModal() {
      this.checkoutModalOpen = false;
      document.body.style.overflow = 'auto';
    },
    
    submitCheckoutForm() {
      this.sendWhatsAppMessage(this.checkoutForm);
    },
    
    sendWhatsAppMessage(formData) {
      let message = `Halo, saya ingin memesan ikan asap:\n\n`;
      
      this.cart.forEach(item => {
        const itemTotal = item.variant.discountedPrice * item.quantity;
        const itemOriginalTotal = item.variant.price * item.quantity;
        
        if (item.variant.discount > 0) {
          message += `- ${item.name} (${item.variant.weight}) x${item.quantity}: Rp ${this.formatPrice(itemTotal)} (Diskon ${item.variant.discount}% dari Rp ${this.formatPrice(itemOriginalTotal)})\n`;
        } else {
          message += `- ${item.name} (${item.variant.weight}) x${item.quantity}: Rp ${this.formatPrice(itemTotal)}\n`;
        }
      });
      
      message += `\nSubtotal: Rp ${this.formatPrice(this.subtotal)}`;
      
      if (this.totalDiscount > 0) {
        message += `\nDiskon: -Rp ${this.formatPrice(this.totalDiscount)}`;
      }
      
      message += `\nBiaya Pengiriman (Paxel Beku): Rp ${this.formatPrice(this.shippingCost)}`;
      message += `\n*Total: Rp ${this.formatPrice(this.total)}*`;
      
      message += `\n\n*Data Pengiriman:*`;
      message += `\nNama: ${formData.name}`;
      message += `\nNo. WhatsApp: ${formData.phone}`;
      message += `\nAlamat: ${formData.address}`;
      message += `\nKota: ${formData.city}`;
      message += `\nKode Pos: ${formData.postalCode}`;
      
      // Tambahkan metode pembayaran ke pesan
      message += `\n*Metode Pembayaran:* ${formData.paymentMethod}`;
      
      // Tambahkan info rekening berdasarkan metode pembayaran
      message += `\n\n*Info Pembayaran:*`;
      
      if (formData.paymentMethod === 'Dana') {
        message += `\n- Silakan transfer ke Dana: 0857-4122-5546 a/n SUPRIYONO`;
      } else if (formData.paymentMethod === 'BRI') {
        message += `\n- Bank BRI: 5962-0100-6921-538 a/n SUPRIYONO`;
      } else if (formData.paymentMethod === 'BNI') {
        message += `\n- Bank BNI: 1048778658  a/n SRI PUJI LESTARI`;
      } else if (formData.paymentMethod === 'BCA') {
        message += `\n- Bank BCA: 0980134377  a/n SUPRIYONO`;
      }
      
      message += `\n\n*Konfirmasi Bayar:*`;
      message += `\nTransfer sesuai nomor rekening di atas, dan screen shot / tangkapan layar kirim ke sini untuk segera diproses.`;
      
      if (formData.notes) {
        message += `\n\n*Catatan:* ${formData.notes}`;
      }
      
      // Encode message untuk URL
      const encodedMessage = encodeURIComponent(message);
      
      // Nomor WhatsApp toko (ganti dengan nomor asli)
      const phoneNumber = "6288985114082";
      
      // Buka WhatsApp
      window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
      
      // Reset form dan keranjang setelah dikirim
      this.checkoutForm.name = "Nama Pelanggan";
      this.checkoutForm.phone = "6288985114082";
      this.checkoutForm.address = "Jl. Contoh No. 123, Kelurahan Contoh";
      this.checkoutForm.city = "Jakarta Selatan";
      this.checkoutForm.postalCode = "12345";
      this.checkoutForm.notes = "";
      this.checkoutForm.paymentMethod = "Dana";
      
      this.cart = [];
      this.saveCartToStorage();
      this.closeCheckoutModal();
      
      this.showNotification('Pesanan berhasil dikirim via WhatsApp!');
    },
    
    setDefaultCheckoutForm() {
      // Default values already set in data()
    },
    
    showNotification(message, type = 'success') {
      this.notification.message = message;
      this.notification.type = type;
      this.notification.show = true;
      
      setTimeout(() => {
        this.notification.show = false;
      }, 3000);
    }
  }
};
</script>

<style>
/* Reset & Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  /* Light Theme (Deepin OS Inspired) */
  --primary-color: #2ca7f8;
  --primary-dark: #1a8cd8;
  --secondary-color: #6c6cff;
  --background-color: #f8f9fa;
  --surface-color: #ffffff;
  --text-color: #333333;
  --text-secondary: #666666;
  --border-color: #e0e0e0;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --success-color: #4caf50;
  --warning-color: #ff9800;
  --error-color: #f44336;
  --discount-color: #ff4081;
  --card-radius: 12px;
  --element-radius: 8px;
  --transition-speed: 0.3s;
}

[data-theme="dark"] {
  /* Dark Theme (Deepin OS Inspired) */
  --primary-color: #2ca7f8;
  --primary-dark: #1a8cd8;
  --secondary-color: #8a8aff;
  --background-color: #1a1a1a;
  --surface-color: #252525;
  --text-color: #e0e0e0;
  --text-secondary: #a0a0a0;
  --border-color: #404040;
  --shadow-color: rgba(0, 0, 0, 0.3);
  --success-color: #4caf50;
  --warning-color: #ff9800;
  --error-color: #f44336;
  --discount-color: #ff4081;
}

body {
  font-family: 'Inter', sans-serif;
  background-color: var(--background-color);
  color: var(--text-color);
  transition: background-color var(--transition-speed), color var(--transition-speed);
  line-height: 1.6;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Header Styles */
.header {
  background-color: var(--surface-color);
  box-shadow: 0 2px 10px var(--shadow-color);
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 15px 0;
}

.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
}

.logo i {
  margin-right: 10px;
  font-size: 1.8rem;
}

.nav {
  display: flex;
  gap: 30px;
}

.nav-link {
  text-decoration: none;
  color: var(--text-color);
  font-weight: 500;
  padding: 8px 0;
  position: relative;
  transition: color var(--transition-speed);
}

.nav-link:hover {
  color: var(--primary-color);
}

.nav-link.active {
  color: var(--primary-color);
}

.nav-link.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--primary-color);
}

.nav-link span {
  background-color: var(--primary-color);
  color: white;
  border-radius: 50%;
  font-size: 0.8rem;
  padding: 2px 6px;
  margin-left: 5px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.promo-banner {
  background: linear-gradient(135deg, var(--discount-color), #ff79a9);
  color: white;
  padding: 8px 15px;
  border-radius: var(--element-radius);
  font-weight: 600;
  font-size: 0.9rem;
  box-shadow: 0 3px 10px rgba(255, 64, 129, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { box-shadow: 0 3px 10px rgba(255, 64, 129, 0.3); }
  50% { box-shadow: 0 3px 15px rgba(255, 64, 129, 0.5); }
  100% { box-shadow: 0 3px 10px rgba(255, 64, 129, 0.3); }
}

.theme-toggle {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: var(--text-color);
  cursor: pointer;
  padding: 8px;
  border-radius: var(--element-radius);
  transition: background-color var(--transition-speed);
}

.theme-toggle:hover {
  background-color: var(--border-color);
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--text-color);
  cursor: pointer;
  padding: 5px;
}

/* Mobile Menu */
.mobile-menu {
  display: none;
  flex-direction: column;
  background-color: var(--surface-color);
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 99;
  padding: 20px;
  box-shadow: 0 5px 10px var(--shadow-color);
}

.mobile-menu.active {
  display: flex;
}

.mobile-nav-link {
  padding: 15px 0;
  text-decoration: none;
  color: var(--text-color);
  font-weight: 500;
  border-bottom: 1px solid var(--border-color);
}

.mobile-nav-link:last-child {
  border-bottom: none;
}

.mobile-nav-link.active {
  color: var(--primary-color);
}

.mobile-theme-toggle {
  margin-top: 20px;
  padding: 12px;
  background-color: var(--border-color);
  border: none;
  border-radius: var(--element-radius);
  color: var(--text-color);
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

/* Button Styles */
.btn {
  padding: 12px 24px;
  border-radius: var(--element-radius);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-speed);
  border: none;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-primary {
  background-color: var(--primary-color);
  color: white;
}

.btn-primary:hover {
  background-color: var(--primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px var(--shadow-color);
}

.btn-primary:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-primary:disabled:hover {
  background-color: #cccccc;
  transform: none;
  box-shadow: none;
}

.btn-outline {
  background-color: transparent;
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
}

.btn-outline:hover {
  background-color: var(--primary-color);
  color: white;
}

.btn-block {
  width: 100%;
}

/* Hero Section */
.hero {
  padding: 80px 0;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  color: white;
  margin-bottom: 60px;
}

.hero .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

.hero-content {
  flex: 1;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 20px;
  line-height: 1.2;
}

.hero p {
  font-size: 1.2rem;
  margin-bottom: 30px;
  opacity: 0.9;
}

.hero-image {
  flex: 1;
  text-align: center;
}

.hero-image img {
  width: 100%;
  max-width: 500px;
  border-radius: var(--card-radius);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
}

/* Section Styles */
.section-title {
  font-size: 2.5rem;
  margin-bottom: 15px;
  text-align: center;
}

.section-subtitle {
  font-size: 1.1rem;
  color: var(--text-secondary);
  text-align: center;
  margin-bottom: 40px;
}

.products-section, .cart-section, .about-section {
  padding: 60px 0;
}

/* Products Filter */
.products-filter {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 40px;
}

.filter-btn {
  padding: 10px 20px;
  background-color: transparent;
  border: 2px solid var(--border-color);
  border-radius: 30px;
  color: var(--text-color);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-speed);
}

.filter-btn:hover, .filter-btn.active {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}

/* Products Grid */
.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.product-card {
  background-color: var(--surface-color);
  border-radius: var(--card-radius);
  overflow: hidden;
  box-shadow: 0 5px 15px var(--shadow-color);
  transition: transform var(--transition-speed);
  position: relative;
}

.product-card:hover {
  transform: translateY(-10px);
}

.product-badge {
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 2;
}

.discount-badge {
  background-color: var(--discount-color);
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 5px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
}

.product-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.product-info {
  padding: 20px;
}

.product-name {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.product-description {
  color: var(--text-secondary);
  font-size: 0.95rem;
  margin-bottom: 15px;
  line-height: 1.5;
}

.product-pricing {
  margin-bottom: 15px;
  min-height: 50px;
}

.original-price {
  text-decoration: line-through;
  color: var(--text-secondary);
  font-size: 0.95rem;
  margin-bottom: 3px;
}

.discounted-price {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
  line-height: 1.2;
}

.product-price {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 10px;
  line-height: 1.2;
}

.product-stock {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;
  font-size: 0.9rem;
}

.stock-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}

.stock-in {
  background-color: rgba(76, 175, 80, 0.1);
  color: var(--success-color);
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.stock-low {
  background-color: rgba(255, 152, 0, 0.1);
  color: var(--warning-color);
  border: 1px solid rgba(255, 152, 0, 0.3);
}

.stock-out {
  background-color: rgba(244, 67, 54, 0.1);
  color: var(--error-color);
  border: 1px solid rgba(244, 67, 54, 0.3);
}

.variant-selector {
  margin-bottom: 15px;
}

.variant-selector label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.variant-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.variant-btn {
  padding: 8px 15px;
  background-color: transparent;
  border: 1px solid var(--border-color);
  border-radius: var(--element-radius);
  color: var(--text-color);
  cursor: pointer;
  transition: all var(--transition-speed);
  position: relative;
}

.variant-btn:hover:not(:disabled) {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.variant-btn.active {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}

.variant-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  position: relative;
  overflow: hidden;
}

.variant-btn:disabled::after {
  content: 'Habis';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--error-color);
  color: white;
  font-size: 0.7rem;
  padding: 2px 5px;
  border-radius: 3px;
  font-weight: 600;
}

.stock-info {
  font-size: 0.7rem;
  position: absolute;
  bottom: -8px;
  right: 2px;
  background: white;
  padding: 0 4px;
  color: var(--text-secondary);
}

.variant-btn:disabled .stock-info {
  color: var(--error-color);
}

.add-to-cart-btn {
  width: 100%;
  padding: 12px;
  margin-top: 5px;
}

/* Cart Section */
.cart-container {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 30px;
}

.cart-items {
  background-color: var(--surface-color);
  border-radius: var(--card-radius);
  padding: 25px;
  box-shadow: 0 5px 15px var(--shadow-color);
}

.empty-cart {
  text-align: center;
  padding: 50px 20px;
}

.empty-cart i {
  font-size: 4rem;
  color: var(--border-color);
  margin-bottom: 20px;
}

.empty-cart p {
  font-size: 1.2rem;
  margin-bottom: 25px;
  color: var(--text-secondary);
}

.cart-item {
  display: flex;
  padding: 20px 0;
  border-bottom: 1px solid var(--border-color);
}

.cart-item:last-child {
  border-bottom: none;
}

.cart-item-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: var(--element-radius);
  margin-right: 20px;
}

.cart-item-details {
  flex: 1;
}

.cart-item-name {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.cart-item-variant {
  color: var(--text-secondary);
  margin-bottom: 10px;
}

.cart-item-pricing {
  margin-bottom: 15px;
}

.cart-item-price {
  font-weight: 700;
  color: var(--primary-color);
}

.cart-item-original-price {
  text-decoration: line-through;
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin-left: 8px;
}

.cart-item-discount {
  background-color: var(--discount-color);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.8rem;
  margin-left: 8px;
  font-weight: 600;
}

.cart-item-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.quantity-control {
  display: flex;
  align-items: center;
  gap: 10px;
}

.quantity-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--border-color);
  border: none;
  color: var(--text-color);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity {
  font-weight: 600;
  min-width: 30px;
  text-align: center;
}

.remove-item {
  background: none;
  border: none;
  color: var(--error-color);
  cursor: pointer;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: var(--element-radius);
}

.remove-item:hover {
  background-color: rgba(244, 67, 54, 0.1);
}

.cart-summary {
  background-color: var(--surface-color);
  border-radius: var(--card-radius);
  padding: 25px;
  box-shadow: 0 5px 15px var(--shadow-color);
  height: fit-content;
  position: sticky;
  top: 100px;
}

.cart-summary h3 {
  font-size: 1.5rem;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--border-color);
}

.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.summary-item.discount {
  color: var(--discount-color);
}

.summary-item.total {
  font-size: 1.3rem;
  font-weight: 700;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
}

/* About Section */
.about-content {
  display: flex;
  align-items: center;
  gap: 50px;
}

.about-text {
  flex: 1;
}

.about-text p {
  margin-bottom: 20px;
  font-size: 1.1rem;
}

.features {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 30px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: var(--surface-color);
  padding: 15px;
  border-radius: var(--element-radius);
  box-shadow: 0 3px 10px var(--shadow-color);
  flex: 1;
  min-width: 150px;
}

.feature i {
  font-size: 1.5rem;
  color: var(--primary-color);
}

.about-image {
  flex: 1;
  text-align: center;
}

.about-image img {
  width: 100%;
  max-width: 500px;
  border-radius: var(--card-radius);
  box-shadow: 0 10px 25px var(--shadow-color);
}

/* Footer */
.footer {
  background-color: var(--surface-color);
  padding: 50px 0 20px;
  margin-top: auto;
  box-shadow: 0 -5px 15px var(--shadow-color);
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
  flex-wrap: wrap;
  gap: 40px;
}

.footer-logo {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
}

.footer-logo i {
  margin-right: 10px;
  font-size: 1.8rem;
}

.footer-info p {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-info i {
  color: var(--primary-color);
  width: 20px;
}

.footer-social {
  display: flex;
  gap: 15px;
}

.footer-social a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: var(--border-color);
  border-radius: 50%;
  color: var(--text-color);
  text-decoration: none;
  font-size: 1.2rem;
  transition: all var(--transition-speed);
}

.footer-social a:hover {
  background-color: var(--primary-color);
  color: white;
  transform: translateY(-3px);
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
  color: var(--text-secondary);
}

/* Modal */
.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.modal.active {
  display: flex;
}

.modal-content {
  background-color: var(--surface-color);
  border-radius: var(--card-radius);
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px;
  border-bottom: 1px solid var(--border-color);
}

.modal-header h3 {
  font-size: 1.8rem;
}

.modal-close {
  background: none;
  border: none;
  font-size: 2rem;
  color: var(--text-color);
  cursor: pointer;
  line-height: 1;
}

.modal-body {
  padding: 25px;
}

/* Form Styles */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-group input, .form-group textarea {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid var(--border-color);
  border-radius: var(--element-radius);
  background-color: var(--background-color);
  color: var(--text-color);
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  transition: border-color var(--transition-speed);
}

.form-group input:focus, .form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color);
}

.order-summary {
  margin: 30px 0;
  padding: 20px;
  background-color: var(--background-color);
  border-radius: var(--element-radius);
}

.order-summary h4 {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border-color);
}

.order-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.order-item:last-child {
  margin-bottom: 0;
}

/* Payment Methods Styles */
.payment-methods {
  margin-top: 20px;
}

.payment-category {
  margin-bottom: 25px;
}

.payment-category h4 {
  font-size: 1.1rem;
  margin-bottom: 15px;
  color: var(--text-color);
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-color);
}

.payment-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.payment-option {
  display: block;
  cursor: pointer;
}

.payment-option input[type="radio"] {
  display: none;
}

.payment-card {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: var(--surface-color);
  border: 2px solid var(--border-color);
  border-radius: var(--element-radius);
  transition: all var(--transition-speed);
}

.payment-card:hover {
  border-color: var(--primary-color);
  transform: translateY(-2px);
}

.payment-option input[type="radio"]:checked + .payment-card {
  border-color: var(--primary-color);
  background-color: rgba(44, 167, 248, 0.1);
  box-shadow: 0 5px 15px var(--shadow-color);
}

.payment-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-color);
  color: white;
  border-radius: 8px;
  margin-right: 15px;
  font-size: 1.2rem;
}

.payment-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.payment-name {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 4px;
}

.payment-desc {
  font-size: 0.9rem;
  color: var(--text-secondary);
}

/* Tambahan untuk form-group di modal */
.modal-body .form-group {
  margin-bottom: 25px;
}

.form-actions {
  display: flex;
  gap: 15px;
}

/* Notification */
.notification {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: var(--success-color);
  color: white;
  padding: 15px 25px;
  border-radius: var(--element-radius);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  transform: translateY(100px);
  opacity: 0;
  transition: transform 0.4s, opacity 0.4s;
  z-index: 1001;
}

.notification.active {
  transform: translateY(0);
  opacity: 1;
}

.notification.warning {
  background-color: var(--warning-color);
}

.notification.error {
  background-color: var(--error-color);
}

/* Style untuk tampilan metode pembayaran di ringkasan */
.payment-method-display {
  padding-top: 15px;
  border-top: 2px dashed var(--border-color);
  margin-top: 15px;
}

/* Responsive Styles */
@media (max-width: 992px) {
  .hero .container {
    flex-direction: column;
    text-align: center;
  }
  
  .about-content {
    flex-direction: column;
  }
  
  .cart-container {
    grid-template-columns: 1fr;
  }
  
  .cart-summary {
    position: static;
  }
}

@media (max-width: 768px) {
  .nav, .header-actions .btn-outline {
    display: none;
  }
  
  .mobile-menu-btn {
    display: block;
  }
  
  .hero h1 {
    font-size: 2.2rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
  
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .promo-banner {
    display: none;
  }
}

@media (max-width: 576px) {
  .products-grid {
    grid-template-columns: 1fr;
  }
  
  .cart-item {
    flex-direction: column;
  }
  
  .cart-item-image {
    width: 100%;
    height: 200px;
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .features {
    flex-direction: column;
  }
  
  .products-filter {
    justify-content: flex-start;
    overflow-x: auto;
    padding-bottom: 10px;
  }
}
  /* Logo Styles */
.logo {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
}

.logo-image {
  width: 40px; /* Sesuaikan ukuran */
  height: 40px;
  margin-right: 10px;
  object-fit: contain;
}

.footer-logo {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
}
</style>
